import config from './apiConfig.json';

export const joinApiUrl = (base: string | undefined, endpoint: string): string => {
  const cleanBase = (base || '').replace(/\/+$/, '');
  let path = endpoint.replace(/^\/+/, '');
  for (const segment of ['srisai', 'api']) {
    if (cleanBase.endsWith(`/${segment}`) && (path === segment || path.startsWith(`${segment}/`))) path = path.slice(segment.length).replace(/^\/+/, '');
  }
  return path ? `${cleanBase}/${path}` : cleanBase;
};

// Production requires an explicitly approved origin at build time.
export const apiBase = (process.env.NODE_ENV === 'production' ? config.production : process.env.NODE_ENV === 'development' ? config.development : (process.env.REACT_APP_API_URL || config.development)).replace(/\/+$/, '');
export const apiUrl = (endpoint: string): string => joinApiUrl(apiBase, endpoint);
export const mediaUrl = (value: string): string => /^https?:\/\//i.test(value) ? value : joinApiUrl(apiBase, value);
